import React from "react";

export default class AVHomePlaceholder extends React.PureComponent {
  render() {
    return (
      <div className="food-app-placeholder">
        <style>
          {`
            @keyframes shimmerAnimation {
              0% {
                background-position: -468px 0;
              }
              100% {
                background-position: 468px 0;
              }
            }

            .food-app-placeholder {
              display: flex;
              flex-direction: column;
              padding: 20px;
            }

            .circle-placeholder,
            .rectangle-placeholder {
              background-color: #e0e0e0;
              background-image: linear-gradient(
                to right,
                #e0e0e0 0%,
                #f5f5f5 20%,
                #e0e0e0 40%,
                #e0e0e0 100%
              );
              background-repeat: no-repeat;
              background-size: 800px 140px; /* Width should be large to ensure a smooth transition */
              animation-duration: 1.5s;
              animation-fill-mode: forwards;
              animation-iteration-count: infinite;
              animation-name: shimmerAnimation;
              animation-timing-function: linear;
            }

            .circle-placeholder {
              width: 70px;
              height: 70px;
              border-radius: 50%;
              box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
              margin: 10px 0;
            }

            .rectangle-placeholder {
              width: 100%;
              height: 160px;
              box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
              margin-bottom: 10px;
            }

            .category-row,
            .restaurant-row {
              display: flex;
              justify-content: space-between;
              margin-bottom: 20px;
            }
          `}
        </style>
        <div className="category-row">
          <div className="circle-placeholder"></div>
          <div className="circle-placeholder"></div>
          <div className="circle-placeholder"></div>
          <div className="circle-placeholder"></div>
        </div>
        <div className="restaurant-row">
          <div className="rectangle-placeholder"></div>
          <div className="rectangle-placeholder"></div>
        </div>
        {/* Repeat the restaurant row as needed */}
        <div className="restaurant-row">
          <div className="rectangle-placeholder"></div>
          <div className="rectangle-placeholder"></div>
        </div>

        <div className="restaurant-row">
          <div className="rectangle-placeholder"></div>
          <div className="rectangle-placeholder"></div>
        </div>
      </div>
    );
  }
}
